import React from "react";
import { Info } from "lucide-react";

export const AffiliateDisclosure = ({ compact = false }) => (
  <div
    data-testid="affiliate-disclosure"
    className={`flex items-start gap-2 rounded-lg border border-gold/40 bg-gold/10 text-navy ${
      compact ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm"
    }`}
  >
    <Info className={`${compact ? "w-4 h-4" : "w-5 h-5"} text-brick shrink-0 mt-0.5`} />
    <p className="leading-relaxed">
      <strong>Affiliate disclosure:</strong> The Gorilla Gateway links to products on third-party
      retailers. JohnnyMart may earn a commission if you buy through these links, at no extra cost to
      you. You complete your purchase directly with the retailer — these items are <em>not</em> sold by
      JohnnyMart and never enter the JohnnyMart cart or checkout.
      {" "}<span className="block mt-1 font-semibold">As an Amazon Associate, JohnnyMart earns from qualifying purchases.</span>
    </p>
  </div>
);
